import '../../../sass/screens/sign_in/index.scss';

import { initializeForm } from '../../utils/form';
import { validateEmail, validatePassword } from '../../utils/validators';
import { initializeRecaptcha } from '../../utils/recaptcha';
import { appInsights } from '../../services/appinsights.service';

$(() => {
  console.log('sign_in.js loaded');
  console.log(appInsights);
  appInsights.trackEvent({
    name: 'sign_in.js loaded',
    properties: {
      message: 'sign_in.js loaded',
    },
  });
  const singInFormSelector = $('#sign-in-form');

  initializeRecaptcha();

  initializeForm(singInFormSelector, {
    preventDefault: false,
    validate: (values) => {
      const errors = {
        ...validateEmail(values),
        ...validatePassword(values),
      };
      return errors;
    },
  });
});
